import type { PublicConfig } from "../../domain/app-types.ts";
import { escapeHtml } from "../../ui/text.ts";

export interface AuthViewOptions {
  registrationMode: PublicConfig["registration_mode"];
  message?: string;
  icon(name: string): string;
  logo(): string;
}

export function authView({ registrationMode, message = "", icon, logo }: AuthViewOptions): string {
  return `
    <main class="auth-layout">
      <section class="auth-intro">
        <div class="brand brand--large">${logo()}<span>WeirDo</span></div>
        <p class="eyebrow">Local-first clarity</p>
        <h1>Make space for<br><span>what matters.</span></h1>
        <p class="auth-copy">A calm todo space that keeps working wherever you are—even when your connection does not.</p>
        <div class="feature-pills"><span>${icon("offline")} Works offline</span><span>${icon("spark")} Conflict-safe</span></div>
      </section>
      <section class="auth-card" aria-labelledby="auth-title">
        <div class="mobile-brand">${logo()} WeirDo</div>
        <p class="eyebrow">Welcome</p>
        <h2 id="auth-title">Sign in to your space</h2>
        <p class="muted">Your tasks will be available on this device after the first sync.</p>
        <div class="notice ${message ? "notice--error" : ""}" role="${message ? "alert" : "status"}" data-auth-feedback ${message ? "" : "hidden"}>${escapeHtml(message)}</div>
        <form id="auth-form">
          <label>Email<input name="email" type="email" autocomplete="email" required placeholder="you@example.com"></label>
          <label>Password<input name="password" type="password" autocomplete="current-password" minlength="10" required placeholder="At least 10 characters"></label>
          ${registrationMode === "allowlist" ? '<label class="registration-code" hidden>Registration code<input name="registration_code" type="password" autocomplete="off" disabled placeholder="Provided by the administrator"></label>' : ""}
          <button class="button button--primary button--wide" type="submit">Sign in</button>
        </form>
        <p class="auth-switch"><button class="text-button" id="forgot-password" type="button">Forgot password?</button></p>
        ${registrationMode === "closed" ? '<p class="auth-switch">Accounts are created by the server administrator.</p>' : `<p class="auth-switch">${registrationMode === "allowlist" ? "Invited?" : "New here?"} <button class="text-button" id="register" type="button">${registrationMode === "allowlist" ? "Create an approved account" : "Create an account"}</button></p>`}
        <p class="auth-credit">Weirdo, by Weirdloop</p>
      </section>
    </main>`;
}
